var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DottedSpinner',{attrs:{"color":'#0D7542'}}),_c('h3',{staticStyle:{"color":"#0D7542","text-align":"center"}},[_vm._v("Creating New Account...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }